






















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import CardTitle from '@/components/common/CardTitle.vue';
import CardDesignPreview from '@/components/apps/CardDesignPreview.vue';
import Apps from '@/store/modules/Apps';
import AppsSubscribeButton from '@/components/apps/AppsSubscribeButton.vue';
import CardDesignMainPage from '@/components/apps/CardDesignMainPage.vue';

const appModule = getModule(Apps);

@Component({
    name: 'CardDesign',
    components: {
        CardTitle,
        CardDesignPreview,
        AppsSubscribeButton,
        CardDesignMainPage
    },
    directives: {},
})
export default class CardDesign extends Vue {
    private show = false;

        // private apps = [
        //     {
        //         previewUrl:
        //             'https://i.guim.co.uk/img/media/dd703cd39013271a45bc199fae6aa1ddad72faaf/0_0_2000_1200/master/2000.jpg?width=1200&height=1200&quality=85&auto=format&fit=crop&s=178a9434c272d5a067353f57a30f58ed',
        //         imageMain:
        //             'https://i.guim.co.uk/img/media/dd703cd39013271a45bc199fae6aa1ddad72faaf/0_0_2000_1200/master/2000.jpg?width=1200&height=1200&quality=85&auto=format&fit=crop&s=178a9434c272d5a067353f57a30f58ed',
        //         subscriptionStatus: false,
        //         tags: ['pikapika', 'pikachu'],
        //         name: 'PikachuBossPikachuBossPikachuBoss',
        //         rating: 5,
        //         cta:
        //             'Pikachu Boss is Here!Pikachu are small, mouse-like Pokémon that have short, yellow fur with brown markings covering their backs and parts of their tails. [9] They have black-tipped, pointy ears and red circles on their cheeks, which are said to contain "electrical sacs". [3] Their tails are shaped in the form of a lightning bolt.',
        //         reviewCount: 56,
        //     },
        //     {
        //         previewUrl:
        //             'https://d2skuhm0vrry40.cloudfront.net/2021/articles/2021-05-05-11-45/detective-pikachu-star-pours-water-on-those-sequel-plans-1620211502511.jpg/EG11/thumbnail/732x412/format/jpg/quality/50',
        //         imageMain:
        //             'https://d2skuhm0vrry40.cloudfront.net/2021/articles/2021-05-05-11-45/detective-pikachu-star-pours-water-on-those-sequel-plans-1620211502511.jpg/EG11/thumbnail/732x412/format/jpg/quality/50',
        //         subscriptionStatus: false,
        //         tags: ['cry', 'sad', 'hungry'],
        //         name: 'Pika',
        //         rating: 4,
        //         cta: 'AWWWWWWWWWWWWWWWWWWWAWWWWWWWWWWWWWAWWWWWWWWWWWAWWWWWW',
        //         reviewCount: 787,
        //     },
        //     {
        //         previewUrl:
        //             'https://cdn.vox-cdn.com/thumbor/eFEHo8eygHajtwShwT9e_jf7c-c=/0x0:1920x1080/1200x800/filters:focal(722x227:1028x533)/cdn.vox-cdn.com/uploads/chorus_image/image/69323002/Screen_Shot_2021_05_21_at_9.54.00_AM.0.jpeg',
        //         imageMain:
        //             'https://cdn.vox-cdn.com/thumbor/eFEHo8eygHajtwShwT9e_jf7c-c=/0x0:1920x1080/1200x800/filters:focal(722x227:1028x533)/cdn.vox-cdn.com/uploads/chorus_image/image/69323002/Screen_Shot_2021_05_21_at_9.54.00_AM.0.jpeg',
        //         subscriptionStatus: false,
        //         tags: ['pikapika', 'pikachu'],
        //         name: 'Pikachu Arrested',
        //         rating: 2,
        //         cta:
        //             'Ash’s Pikachu was taken in by the authorities on this week’s episode of the newest iteration of the Pokémon anime. The crime in question? Electricity stolen from various residences in Vermillion City, according to a recap of the episode by Kotaku.',
        //         reviewCount: 56,
        //     },
        //     {
        //         previewUrl:
        //             'https://m.media-amazon.com/images/I/51zkuu5jLxL._AC_SX679_.jpg',
        //         imageMain:
        //             'https://m.media-amazon.com/images/I/51zkuu5jLxL._AC_SX679_.jpg',
        //         subscriptionStatus: false,
        //         tags: ['pikapika', 'pikachu'],
        //         name: 'Eww Pikachu',
        //         rating: 1,
        //         cta:
        //             'Funny Wretched Expression Pikachu Pokemon Pokemon PVC Anime Action Figure Around Birthday Gift',
        //         reviewCount: 568,
        //     },
        // ];
    get selectedAppId() {
        return appModule.selectedAppId;
    }

    get apps() {
        return appModule.apps;
    }
}
